import { Pipe, PipeTransform } from '@angular/core';
import { Time } from '@angular/common';

@Pipe({
    name: 'scheduletime'
})
export class ScheduletimePipe implements PipeTransform {

    transform(value: Time, args?: any): any {
        const h: String = `0${value.hours}`.slice(-2);
        const m: String = `0${value.minutes}`.slice(-2);
        return `${h}:${m}`;
    }

}
